import { render, staticRenderFns } from "./TestTypes.vue?vue&type=template&id=6d1c4682&scoped=true&"
import script from "./TestTypes.vue?vue&type=script&lang=js&"
export * from "./TestTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c4682",
  null
  
)

export default component.exports